import { Alert, Link, Typography, Stack } from '@mui/material'
import { FC } from 'react'
import { DateTime } from 'luxon'
import { useAvailableTicketsQuery } from '~/generated/graphql'
import { pagesPath } from '~/lib/$path'
import NextLink from 'next/link'

export const TicketsExpireSoonAlert: FC = () => {
  const { data, loading, error } = useAvailableTicketsQuery()
  if (loading || error) return null

  const availableTickets = data?.viewer.company?.availableTickets
  const ticketsExpireSoon = availableTickets?.filter(
    (x) => DateTime.fromISO(x.expiredAt) < DateTime.now().plus({ days: 7 }),
  )
  const ticketsExpireSoonCount = ticketsExpireSoon?.length ?? 0

  if (ticketsExpireSoonCount === 0) return null

  return (
    <Alert severity="warning">
      <Stack spacing={0.5}>
        <Link
          component={NextLink}
          href={pagesPath.campaign_create.$url()}
          sx={{
            textDecoration: 'underline',
            '&:hover': {
              textDecoration: 'underline',
            },
            color: 'inherit',
          }}
        >
          <Typography variant="labelMJpNormalMedium" color="warning.160p">
            有効期限が迫っているチケットがあります
          </Typography>
        </Link>
        <Typography variant="labelMJpNormalMedium" color="warning.160p">
          チケットはキャンペーンの審査提出に必要です。チケットは有効期限が切れると使用できなくなります。チケットの期限切れによる返金はできません。
        </Typography>
      </Stack>
    </Alert>
  )
}
